import { FC } from 'react'
import { containers as embedCodeContainers } from '@features/embed_code'
import { Shareable } from '@app-types/entity_types'
import HorizontalSpinner from '@components/HorizontalSpinner'
const { EmbedCodeContainer } = embedCodeContainers

type EmbedStepProps = {
  shareable?: Shareable
  status: string
  isPublished: boolean
}

const EmbedStep: FC<EmbedStepProps> = ({ shareable, status, isPublished }) => {
  return shareable ? (
    <EmbedCodeContainer
      host={shareable.host}
      timelineId={shareable.id}
      isPublished={isPublished}
      allowEmbedding={shareable.allow_embedding}
    />
  ) : (
    <HorizontalSpinner size="large" />
  )
}

export default EmbedStep
